import React from 'react'
import { FaHeart } from 'react-icons/fa'

function FooterComponent() {
  return (
    <span className="myFooter">For the sake of Allah
      <FaHeart style={{ color: '#e75225', paddingTop: '5px', fontSize: '18px' }} />
    </span>
  )
}

export default FooterComponent